import styled, { css } from 'styled-components';

import { RowCentered } from 'pages/Login/style';
import { pxToRem } from 'utils/scss';

export const ForgotPasswordTitle = styled.div`
  padding-top: ${props => (props.onManagePersonalData ? 0 : pxToRem('70px'))}
  color: ${props => props.theme.colors.white};
  display: flex;
  justify-content: center;
`;
export const TCText = styled.div`
  width:100%;
  text-align: center;
  color:white;
  font-size: ${pxToRem('14px')}
  line-height: 1.57;
  font-weight: 600;
`;

export const ErrorWrapper = styled(RowCentered)`
  padding-top: ${pxToRem('16px')};
  padding-bottom: ${pxToRem('16px')};

  ${props =>
    props.createPassword &&
    css`
      padding-top: ${pxToRem('55px')};
      padding-bottom: ${pxToRem('0px')};
    `}
`;

export const PhoneSection = styled.div`
  border-radius: ${pxToRem('6px')};
  margin-top:${pxToRem('24px')}
  
  border: ${pxToRem('1px')} solid
    ${props =>
      props.status === 'invalid'
        ? props.theme.colors.redError
        : 'rgba(255, 255, 255, 0.8)'};
  background-color: rgba(255, 255, 255, 0.32);
  padding: ${pxToRem('8px')}
  display: flex;
  
  &>div{
    :is(:first-child){
      width:30%;
    }
  }
`;
